/*
 * @Author: 晋枫
 * @Date: 2021-09-25 17:15:13
 * @LastEditTime: 2021-09-25 17:45:24
 * @LastEditors: 晋枫
 * @Description:
 * @FilePath: /jmj-7v1-task/src/views/wxapp/bulletin-board/workbench-v2/constant.js
 * 🍁YOU CAN（NOT）REDO🍁
 */

export const WORK_ORDER_TYPES = {
  /** 经营工单类型ID */
  OPERATE: '1',
  /** 业务工单类型ID */
  BUSINESS: '2',
  /** 体验工单类型ID */
  EXPERIENCE: '3'
}

export const WORK_ORDER_TYPE_ID = 'work_order_type_id'

export const routeAddWorkOrderId = (routes, id) => {
  routes.forEach(route => {
    if (route.meta) {
      route.meta[WORK_ORDER_TYPE_ID] = id
    } else {
      route.meta = { [WORK_ORDER_TYPE_ID]: id }
    }

    route.children && routeAddWorkOrderId(route.children, id)
  })

  return routes
}
